import { ObjectStorage } from "../ObjectStorage";

class OAuthStorage extends ObjectStorage {
    public isSecure = true;
    public key = 'oAuth';
}

export default OAuthStorage.getInstance(OAuthStorage);
